// extracted by mini-css-extract-plugin
module.exports = {"headline":"collection-title-with-arrow-m__headline__13Hgx","headline-text":"collection-title-with-arrow-m__headline-text__2qtP3"};